// extracted by mini-css-extract-plugin
export default {"container":"_1CSVHjurn6yPOpjuJtFSBi"};